// extracted by mini-css-extract-plugin
module.exports = {"form-wrapper":"settingsSupplierEditView_form-wrapper__22Rcu"};